import l, { deserialize as f } from "@fond-of/api-client";
const w = async (s, a, t, e = {}) => await s.post(`customers/${a}/addresses`, {
  ...e,
  json: {
    data: {
      type: "addresses",
      attributes: t
    }
  }
}).json(), P = async (s, a, t, e, r = {}) => await s.patch(`customers/${a}/addresses/${t}`, {
  ...r,
  json: {
    data: {
      type: "addresses",
      attributes: e
    }
  }
}).json(), j = (s) => {
  if (s)
    return new URLSearchParams(s);
}, k = (...s) => s.reduce(
  (a, t) => {
    const e = j(t);
    return e != null && e.toString() && a.toString() ? new URLSearchParams(
      `${e.toString()}&${a.toString()}`
    ) : e != null && e.toString() ? e : a;
  },
  new URLSearchParams()
), c = (s, ...a) => {
  const t = k(...a), e = t == null ? void 0 : t.get("include");
  return t == null || t.set(
    "include",
    [s, e].filter((r) => !!r).join(",")
  ), t;
}, n = "gift-cards,concrete-products,concrete-product-prices,concrete-product-image-sets,promotional-items", i = ({
  guestCartItems: s,
  items: a,
  ...t
}) => ({
  ...t,
  cartItems: s || a || []
}), m = (s) => async (a) => {
  if (!a.headers.has("Authorization"))
    return await s();
}, $ = async (s, a, t = {}) => i(
  await s.post("carts", {
    uuid: !1,
    auth: !0,
    ...t,
    searchParams: c(
      "items",
      {
        include: n
      },
      t.searchParams
    ),
    json: {
      data: {
        type: "carts",
        attributes: {
          priceMode: "GROSS_MODE",
          currency: "EUR",
          name: "UNKNOWN",
          store: a
        }
      }
    }
  }).json()
), R = (s, a, t, e = {}) => s.post(`carts/${a}/items`, {
  uuid: !1,
  auth: !0,
  ...e,
  searchParams: c(
    "items",
    {
      include: n
    },
    e.searchParams
  ),
  json: {
    data: {
      type: "items",
      attributes: t
    }
  }
}), S = (s, a, t = {}) => s.post("guest-cart-items", {
  auth: !1,
  uuid: !0,
  ...t,
  searchParams: c(
    "guest-cart-items",
    {
      include: n
    },
    t.searchParams
  ),
  json: {
    data: {
      type: "guest-cart-items",
      attributes: a
    }
  }
}), b = async (s, a, t, e = {}) => i(
  await R(s, a, t, {
    ...e,
    hooks: {
      beforeRequest: [
        m(
          () => S(s, t, e)
        )
      ]
    }
  }).json()
), G = (s, a, t = {}) => s.get(`carts/${a}/`, {
  auth: !0,
  uuid: !1,
  ...t,
  searchParams: c(
    "items",
    {
      include: n
    },
    t.searchParams
  )
}), A = (s, a, t = {}) => s.get(`guest-carts/${a}`, {
  auth: !1,
  uuid: !0,
  ...t,
  searchParams: c(
    "guest-cart-items",
    {
      include: n
    },
    t.searchParams
  )
}), p = async (s, a, t = {}) => i(
  await G(s, a, {
    ...t,
    searchParams: c(
      "items",
      {
        include: n
      },
      t.searchParams
    ),
    hooks: {
      beforeRequest: [
        m(
          () => A(s, a, t)
        )
      ]
    }
  }).json()
), I = (s, a, t, e = {}) => s.patch(`carts/${a}/items/${t.sku}`, {
  uuid: !1,
  auth: !0,
  ...e,
  searchParams: c(
    "items",
    {
      include: n
    },
    e.searchParams
  ),
  json: {
    data: {
      type: "items",
      attributes: t
    }
  }
}), q = (s, a, t, e = {}) => s.patch(`guest-carts/${a}/guest-cart-items/${t.sku}`, {
  auth: !1,
  uuid: !0,
  ...e,
  searchParams: c(
    "guest-cart-items",
    {
      include: n
    },
    e.searchParams
  ),
  json: {
    data: {
      type: "guest-cart-items",
      attributes: t
    }
  }
}), v = async (s, a, t, e = {}) => i(
  await I(s, a, t, {
    ...e,
    hooks: {
      beforeRequest: [
        m(
          () => q(s, a, t, e)
        )
      ]
    }
  }).json()
), O = (s, a, t, e = {}) => s.delete(`carts/${a}/items/${t}`, {
  uuid: !1,
  auth: !0,
  ...e
}), B = (s, a, t, e = {}) => s.delete(`guest-carts/${a}/guest-cart-items/${t}`, {
  auth: !1,
  uuid: !0,
  ...e
}), U = (s, a, t, e = {}) => O(s, a, t, {
  ...e,
  hooks: {
    beforeRequest: [
      m(
        () => B(s, a, t, e)
      )
    ]
  }
}), z = async (s, a, t = {}) => (await s.get(`customers/${a}/carts`, {
  uuid: !1,
  auth: !0,
  ...t,
  searchParams: c(
    "items",
    {
      include: n
    },
    t.searchParams
  )
}).json()).map((e) => i(e)), E = async (s, a, t, e) => {
  let [r] = await z(s, t, e);
  return r || (r = await $(s, a, e)), r;
}, D = async (s, a = {}) => (await s.get("guest-carts", {
  uuid: !0,
  auth: !1,
  ...a,
  searchParams: c(
    "items",
    {
      include: n
    },
    a.searchParams
  )
}).json()).map((t) => i(t)), M = async (s, a) => {
  const [t] = await D(s, a);
  return t;
}, L = async (s, a, t, e, r = {}) => {
  const o = t == null ? void 0 : t.id, u = (t == null ? void 0 : t.type) === "guestCarts";
  if (o)
    return await p(s, o, r);
  if (!u && !o && e)
    return await E(s, a, e, r);
  if (!o && !e)
    return await M(s, r);
}, T = async (s, a, t, e = {}) => i(
  await s.patch(`carts/${a}`, {
    uuid: !1,
    auth: !0,
    ...e,
    json: {
      data: {
        type: "carts",
        attributes: {
          priceMode: "GROSS_MODE",
          currency: "EUR",
          store: t
        }
      }
    }
  }).json()
), H = async (s, a, t, e = {}) => s.patch(`guest-carts/${a}`, {
  uuid: !0,
  auth: !1,
  ...e,
  json: {
    data: {
      type: "guest-carts",
      attributes: {
        priceMode: "GROSS_MODE",
        currency: "EUR",
        store: t
      }
    }
  }
}), K = (s, a, t, e = {}) => T(s, a, t, {
  ...e,
  hooks: {
    beforeRequest: [
      m(
        () => H(s, a, t, e)
      )
    ]
  }
}), y = (s) => async (a) => {
  if (!a.headers.has("Authorization"))
    return await s();
}, N = (s, a, t, e = {}) => {
  var r;
  return s.post(`carts/${a}/cart-codes`, {
    uuid: !1,
    auth: !0,
    ...e,
    json: {
      data: {
        type: "cart-codes",
        attributes: t
      }
    },
    hooks: {
      ...e.hooks,
      afterResponse: [
        ...((r = e.hooks) == null ? void 0 : r.afterResponse) || [],
        // Handle 422 as a successful request as it will only be returned if the voucher code is incorrect.
        // So we don't need to track the response.
        (o, u, d) => d.status !== 422 ? d : new Response(null, { status: 200 })
      ]
    }
  });
}, _ = (s, a, t, e = {}) => {
  var r;
  return s.post(`guest-carts/${a}/cart-codes`, {
    uuid: !0,
    auth: !1,
    ...e,
    json: {
      data: {
        type: "cart-codes",
        attributes: t
      }
    },
    hooks: {
      ...e.hooks,
      afterResponse: [
        ...((r = e.hooks) == null ? void 0 : r.afterResponse) || [],
        // Handle 422 as a successful request as it will only be returned if the voucher code is incorrect.
        // So we don't need to track the response.
        (o, u, d) => d.status !== 422 ? d : new Response(null, { status: 200 })
      ]
    }
  });
}, F = (s, a, t, e = {}) => N(s, a, t, {
  ...e,
  hooks: {
    beforeRequest: [
      y(
        () => _(s, a, t, e)
      )
    ]
  }
}), W = (s, a, t, e = {}) => s.delete(`carts/${a}/cart-codes/${t}`, {
  uuid: !1,
  auth: !0,
  ...e
}), x = (s, a, t, e = {}) => s.delete(`guest-carts/${a}/cart-codes/${t}`, {
  uuid: !0,
  auth: !1,
  ...e
}), J = (s, a, t, e = {}) => W(s, a, t, {
  ...e,
  hooks: {
    beforeRequest: [
      y(
        () => x(s, a, t, e)
      )
    ]
  }
}), Q = ({
  items: s,
  ...a
}) => ({
  ...a,
  cartItems: s || []
}), V = async (s, a, t = {}) => await s.post("checkout", {
  uuid: !0,
  auth: !0,
  ...t,
  searchParams: c(
    "orders",
    t.searchParams
  ),
  json: {
    data: {
      type: "checkout",
      attributes: a
    }
  }
}).json(), X = async (s, a, t = {}) => {
  const {
    carts: e = [],
    guestCarts: r = [],
    ...o
  } = await s.post("checkout-data", {
    uuid: !0,
    auth: !0,
    ...t,
    searchParams: c(
      "payment-methods,carts,guest-carts,items,concrete-products,concrete-product-prices,concrete-product-image-sets,gift-cards,promotional-items",
      t.searchParams
    ),
    json: {
      data: {
        type: "checkout-data",
        attributes: a
      }
    }
  }).json();
  return {
    ...o,
    carts: [...e, ...r].map(Q)
  };
}, Y = (s, a, t = {}) => s.post("customer-complaints", {
  json: {
    data: {
      type: "customer-complaints",
      attributes: a
    }
  },
  ...t
}).json(), Z = async (s, a = {}) => {
  const t = await s.get("customers", {
    throwHttpErrors: !1,
    searchParams: {
      include: "addresses"
    },
    ...a
  }).json();
  return t == null ? void 0 : t[0];
}, tt = async (s, a, t = {}) => {
  var e;
  return await s.post("customer-registration", {
    throwHttpErrors: !1,
    ...t,
    json: {
      data: {
        type: "customer-registration",
        attributes: a
      }
    },
    hooks: {
      afterResponse: [
        async (r, o, u) => {
          var C;
          if (u.status !== 422)
            return u;
          const d = await u.json(), g = (C = d == null ? void 0 : d.errors) == null ? void 0 : C[0];
          return (g == null ? void 0 : g.code) === "3" ? new Response(null, { status: 200 }) : u;
        },
        ...((e = t.hooks) == null ? void 0 : e.afterResponse) || []
      ]
    }
  });
}, et = async (s, a, t = {}) => await s.post("customer-confirmation", {
  ...t,
  json: {
    data: {
      type: "customer-confirmation",
      attributes: a
    }
  }
}), st = async (s, a, t = {}) => await s.post("customer-forgotten-password", {
  ...t,
  json: {
    data: {
      type: "customer-forgotten-password",
      attributes: a
    }
  }
}), at = async (s, a, t = {}) => await s.patch(
  `customer-restore-password/${a.restorePasswordKey}`,
  {
    ...t,
    json: {
      data: {
        type: "customer-restore-password",
        id: a.restorePasswordKey,
        attributes: a
      }
    }
  }
), rt = async (s, a, t = {}) => await s.post("customer-password-updated", {
  ...t,
  json: {
    data: {
      type: "customer-password-updated",
      attributes: a
    }
  }
}).json(), ot = async (s, a, t = {}) => await s.post("access-tokens", {
  uuid: !0,
  ...t,
  json: {
    data: {
      type: "access-tokens",
      attributes: a
    }
  }
}).json(), ct = async (s, a, t = {}) => await s.post("customers", {
  uuid: !0,
  ...t,
  json: {
    data: {
      type: "customers",
      attributes: {
        ...a,
        confirmPassword: a.password,
        acceptedTerms: !0
      }
    }
  }
}).json(), ut = async (s, a, t = {}) => await s.get(`orders/${a}`, t).json(), nt = async (s, a = {}) => (await s.get("orders", a).json()).map((e) => ({
  ...e,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: e.items.map((r) => ({
    ...r,
    state: r.state.name
  }))
})), h = (s) => {
  var e;
  const a = (e = s.data) == null ? void 0 : e[0].attributes.abstractProducts, [{ abstractProducts: t }] = f(s);
  return t.map(
    (r) => ({
      ...r,
      ...a.find(
        (o) => o.abstractSku === r.sku
      ) || {}
    })
  );
}, dt = async (s, a = {}) => {
  const t = await s.get("catalog-search", {
    ...a,
    searchParams: c(
      "abstract-products",
      a.searchParams
    ),
    deserialize: !1
  }).json();
  return {
    ...t.data[0],
    attributes: {
      ...t.data[0].attributes,
      // @ts-ignore
      abstractProducts: h(t)
    }
  };
}, it = async (s, a, t = {}) => {
  const e = a.map((o) => ["sku[]", `Abstract-${o}`]), r = await s.get("catalog-search", {
    ...t,
    searchParams: c(
      "abstract-products",
      t.searchParams,
      e
    ),
    deserialize: !1
  }).json();
  return h(r);
}, mt = async (s, a, t = {}) => {
  const e = await s.get("catalog-search", {
    ...t,
    searchParams: c(
      "abstract-products",
      {
        category: a
      },
      t.searchParams
    ),
    deserialize: !1
  }).json();
  return h(e);
}, gt = (s, a, t = {}) => s.get(`abstract-products/${a}`, t).json(), ht = async (s, a, t = {}) => await s.get("catalog-search-suggestions", {
  ...t,
  searchParams: {
    q: a
  },
  deserialize: !0
}).json(), pt = {
  new: (s, a = {}) => {
    const t = l.new({
      deserialize: !0,
      ...a,
      prefixUrl: s
    });
    return t.getLoggedInCustomer = (e = {}) => Z(t, e), t.registerCustomer = (e, r = {}) => tt(t, e, r), t.confirmCustomerRegistration = (e, r = {}) => et(t, e, r), t.getCartById = (e, r = {}) => p(t, e, r), t.updateCartItem = (e, r, o = {}) => v(t, e, r, o), t.removeCartItem = (e, r, o = {}) => U(t, e, r, o), t.addCartCode = (e, r, o = {}) => F(t, e, r, o), t.removeCartCode = (e, r, o = {}) => J(t, e, r, o), t.getProductsBySkus = (e, r = {}) => it(t, e, r), t.getProducts = (e = {}) => dt(t, e), t.getProductsByCategory = (e, r = {}) => mt(t, e, r), t.getAbstractProduct = (e, r = {}) => gt(t, e, r), t.getCatalogSearchSuggestions = (e, r = {}) => ht(t, e, r), t.getOrder = (e, r = {}) => ut(t, e, r), t.getOrders = (e = {}) => nt(t, e), t.placeOrder = (e, r = {}) => V(t, e, r), t.provideCheckoutData = (e, r = {}) => X(t, e, r), t.createCustomerAddress = (e, r, o = {}) => w(t, e, r, o), t.updateCustomerAddress = (e, r, o, u = {}) => P(
      t,
      e,
      r,
      o,
      u
    ), t.addToCart = (e, r, o = {}) => b(t, e, r, o), t.getCurrentCart = (e, r, o, u = {}) => L(t, e, r, o, u), t.reloadCart = (e, r, o = {}) => K(t, e, r, o), t.createClaim = (e, r = {}) => Y(t, e, r), t.forgotPassword = (e, r = {}) => st(t, e, r), t.restorePassword = (e, r = {}) => at(t, e, r), t.hasUpdatedPassword = (e, r = {}) => rt(t, e, r), t.login = (e, r = {}) => ot(t, e, r), t.register = (e, r = {}) => ct(t, e, r), t;
  }
};
export {
  pt as default
};
//# sourceMappingURL=spryker-api.js.map
